import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BrokersTab } from "@/pages/BrokersTab";
import { NewsTab } from "@/pages/NewsTab";
import { readSeen, unseenChanges, useAiRanking, writeSeen } from "@/lib/aiRanking";

/** Die gemeinsame Inhaltsspalte von Brokers und News. */
const COLUMN = "mx-auto w-[72vw] min-w-[720px] max-w-[1240px] px-6 py-6";

export function App() {
  const [tab, setTab] = useState("brokers");

  // KI-Rangliste: ungesehene Top-10-Aenderungen -> rotes Badge am News-Tab. Oeffnen des
  // Tabs gilt als gesehen; was dabei neu war, bleibt fuer diesen Besuch markiert.
  const aiRanking = useAiRanking();
  const [aiSeenAt, setAiSeenAt] = useState<string | null>(readSeen);
  const [freshAiChanges, setFreshAiChanges] = useState<Set<string>>(() => new Set());
  const unseenAi = unseenChanges(aiRanking, aiSeenAt);

  useEffect(() => {
    const latest = aiRanking?.changes[0]?.at;
    if (tab !== "news" || !latest || (aiSeenAt && aiSeenAt >= latest)) return;
    const fresh = unseenChanges(aiRanking, aiSeenAt).map((c) => c.at);
    setFreshAiChanges((prev) => new Set([...prev, ...fresh]));
    setAiSeenAt(latest);
    writeSeen(latest);
  }, [tab, aiRanking, aiSeenAt]);

  return (
    <Tabs
      value={tab}
      onValueChange={setTab}
      className="flex h-screen flex-col overflow-hidden text-foreground"
    >
      <main className="flex-1 overflow-y-auto">
        <TabsContent value="brokers" className="mt-0">
          <div className={COLUMN}>
            <BrokersTab />
          </div>
        </TabsContent>
        <TabsContent value="news" className="mt-0">
          <div className={COLUMN}>
            <NewsTab aiRanking={aiRanking} freshAiChanges={freshAiChanges} />
          </div>
        </TabsContent>
      </main>

      {/* Bottom switcher — jump between the tabs from the very bottom. */}
      <div className="sticky bottom-0 z-10 border-t border-border bg-background/70 backdrop-blur">
        <div className="mx-auto flex w-[72vw] min-w-[720px] max-w-[1240px] items-center justify-center px-6 py-2">
          <TabsList className="h-10 w-full max-w-md">
            <TabsTrigger value="brokers" className="flex-1">Brokers</TabsTrigger>
            <TabsTrigger value="news" className="flex-1">
              News
              {unseenAi.length > 0 && (
                <span
                  data-news-badge
                  aria-label="Neue Änderung in den KI-Top-10"
                  className="ml-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-none text-white"
                >
                  {/* immer 1 - der News-Tab zeigt ohnehin nur die neueste Aenderung */}
                  1
                </span>
              )}
            </TabsTrigger>
          </TabsList>
        </div>
      </div>
    </Tabs>
  );
}
